export const LANGUAGES = [
  'Deutsch', 'Englisch', 'Französisch', 'Spanisch', 'Italienisch',
  'Türkisch', 'Arabisch', 'Russisch', 'Polnisch', 'Rumänisch',
  'Niederländisch', 'Portugiesisch', 'Chinesisch', 'Japanisch',
  'Farsi', 'Urdu', 'Vietnamesisch', 'Ukrainisch', 'Kurdisch',
  'Albanisch', 'Griechisch', 'Tschechisch', 'Ungarisch', 'Bulgarisch',
  'Serbokroatisch', 'Koreanisch'
];

export const SPECIALIZATIONS = [
  'Recht', 'Medizin', 'Technik', 'Wirtschaft', 'Behörden',
  'Bildung', 'Sozialwesen', 'Finanzen', 'IT', 'Asylverfahren',
  'Notartermin', 'Gericht'
];

export const SERVICE_TYPES = [
  { value: 'video', label: 'Video' },
  { value: 'telefon', label: 'Telefon' },
  { value: 'vor_ort', label: 'Vor-Ort' },
];

export const MEETING_TOOLS = [
  { value: 'teams', label: 'Microsoft Teams' },
  { value: 'zoom', label: 'Zoom' },
  { value: 'meet', label: 'Google Meet' },
  { value: 'other', label: 'Sonstiges' },
];

export const JOB_STATUSES = [
  { value: 'neu', label: 'Neu' },
  { value: 'in_bearbeitung', label: 'In Bearbeitung' },
  { value: 'gegenvorschlag_gesendet', label: 'Gegenvorschlag gesendet' },
  { value: 'dolmetscher_angefragt', label: 'Dolmetscher angefragt' },
  { value: 'dolmetscher_bestaetigt', label: 'Dolmetscher bestätigt' },
  { value: 'bestaetigt', label: 'Bestätigt' },
  { value: 'meetinglink_versendet', label: 'Meetinglink versendet' },
  { value: 'in_durchfuehrung', label: 'In Durchführung' },
  { value: 'abgeschlossen', label: 'Abgeschlossen' },
  { value: 'storniert', label: 'Storniert' },
];

export const AVAILABILITY_STATUSES = [
  { value: 'verfuegbar', label: 'Verfügbar', color: 'text-green-700 bg-green-50 border-green-200' },
  { value: 'eingeschraenkt', label: 'Eingeschränkt', color: 'text-amber-700 bg-amber-50 border-amber-200' },
  { value: 'nicht_verfuegbar', label: 'Nicht verfügbar', color: 'text-red-700 bg-red-50 border-red-200' },
];

export const statusLabel = (status) => {
  return JOB_STATUSES.find(s => s.value === status)?.label || status;
};

export const statusBadgeClass = (status) => {
  const map = {
    'neu': 'badge-neu',
    'in_bearbeitung': 'badge-in-bearbeitung',
    'gegenvorschlag_gesendet': 'badge-in-bearbeitung',
    'dolmetscher_angefragt': 'badge-dolmetscher-angefragt',
    'dolmetscher_bestaetigt': 'badge-dolmetscher-bestaetigt',
    'bestaetigt': 'badge-bestaetigt',
    'meetinglink_versendet': 'badge-meetinglink-versendet',
    'in_durchfuehrung': 'badge-in-durchfuehrung',
    'abgeschlossen': 'badge-abgeschlossen',
    'storniert': 'badge-storniert',
  };
  return map[status] || 'badge-neu';
};

export const serviceTypeLabel = (t) => SERVICE_TYPES.find(s => s.value === t)?.label || t;
export const meetingToolLabel = (t) => MEETING_TOOLS.find(s => s.value === t)?.label || t;
